export default {
  createFarmWorkRecords: {
    url: '/api/createFarmWorkRecords',
    method: 'post'
  },
  updateFarmWorkRecords: {
    url: '/api/updateFarmWorkRecords',
    method: 'put'
  },
  deleteFarmWorkRecords: {
    url: '/api/deleteFarmWorkRecords',
    method: 'delete'
  },
  getFarmWorkRecords: {
    url: '/api/getFarmWorkRecords',
    method: 'get'
  },
  getFarmWorkType: {
    url: '/api/getFarmWorkType',
    method: 'get'
  },
  deleteFarmWorkType: {
    url: '/api/deleteFarmWorkType',
    method: 'delete'
  }
}
